import React, { Fragment, PureComponent } from 'react';
import { connect } from 'dva';
import { ClockCircleOutlined, InfoCircleOutlined, LoginOutlined } from '@ant-design/icons';
import { Icon as LegacyIcon } from '@ant-design/compatible';
import {
  Radio,
  Input,
  Table,
  Badge,
  Spin,
  Card,
  Button,
  Tag,
  Row,
  Tooltip,
  Col,
  Divider,
  Switch,
  Tree,
  Popover,
  Modal,
  message,
} from 'antd';
import moment from 'moment';
import _ from 'lodash';
import router from 'umi/router';
import { FormattedMessage, formatMessage } from 'umi-plugin-react/locale';
import styles from '../index.less';
import getCloudAccountName from '../../../utils/getCloudAccountName';
import SingleSignatureSuppress from './SingleSignatureSuppress';
import FinderSuppressReason from './FinderSuppressReason';
import { makeSuppressObj, checkSuppression } from '../../../utils/suppressionHelper';
import EmptyData from '../EmptyData';
import { pushParamsToUrl } from '../../../utils/pushParamsToUrl';
import RenderProgressBar from '../../WidgetWrapper/widgets/components/RenderProgressBar';
import { capitalizeFirstLetter } from '../../../helpers/capitalizeFirstLetter';
import { userCan } from '@/utils/authority';
import AllServices from '../../../../config/AllServices';
import InfectedFilesModal from './InfectedFilesModal';
import { riskTypes } from '@/utils/constant';
import { compareStrings, isSuppressionDisabled } from '@/utils/utils';

const radioStyle = {
  display: 'block',
  height: '30px',
  lineHeight: '30px',
};
@connect(({ suppression, universalDrawer, resourcesReport, organisation }) => ({
  supLoading: suppression.supLoading,
  appliedFilters: universalDrawer.appliedFilters,
  notificationResourcesData: universalDrawer.notificationResourcesData,
  loadingReport: resourcesReport.loadingReport, // resource report loader
  packageExpiry: organisation.packageExpiry,
}))
class SingleSignatureResourcesTable extends PureComponent {
  state = {
    suppressResourceCount: 0,
    selectedRowKeys: [],
    value: 'Not Applicable',
    inputVal: '',
    InfectModal: false,
  };

  componentDidUpdate(prevProps, prevState) {
    const {
      notificationResourcesData,
      dispatch,
      filteredResourcesOfSingleRisk,
      drawerLoading,
      riskType,
      signatureName,
    } = this.props;

    // if navigated from notification, then pre select notifiction resources
    if (
      !drawerLoading &&
      filteredResourcesOfSingleRisk !== null &&
      filteredResourcesOfSingleRisk.length > 0 &&
      notificationResourcesData &&
      notificationResourcesData.resources
    ) {
      let resourcesNotExitsCount = 0;
      let stillExistingResources = notificationResourcesData.resources.reduce(
        (notificationResources, eachResource) => {
          if (filteredResourcesOfSingleRisk.some(resource => resource?.id === eachResource?.id)) {
            return [...notificationResources, eachResource?.id];
          } else resourcesNotExitsCount += 1;
          return notificationResources;
        },
        []
      );

      if (resourcesNotExitsCount)
        message.warning(
          `${resourcesNotExitsCount} of ${notificationResourcesData.resources.length} resource(s) from the risk alert no longer exist`
        );

      this.setState({
        selectedRowKeys: stillExistingResources,
      });

      dispatch({
        type: 'universalDrawer/save',
        payload: {
          notificationResourcesData: [],
        },
      });
    }

    if (prevProps.supLoading && !this.props.supLoading) {
      this.setState({
        selectedRowKeys: [],
      });
    }
  }
  onSelectChange = selectedRowKeys => {
    this.setState({ selectedRowKeys });
  };
  getInfectedFiles = () => {
    const { filteredResourcesOfSingleRisk, signatureName } = this.props;
    if (filteredResourcesOfSingleRisk && signatureName) {
      return filteredResourcesOfSingleRisk[0]?.cloudXRayRisks?.malwares[signatureName]
        ?.filesInfected;
    }
  };

  getTableCloumns() {
    let { allCloudAccountsList, riskType } = this.props;

    return [
      {
        title: 'Resource',
        dataIndex: 'name',
        key: 'id',
        width: 300,
        render: (name, record) => {
          let { resourceCreateInCloudnosys, resourceStatus, statusMessage, risks } = record;

          let scannedOn;
          let scannedOnTime;
          let lastSeen;
          let firstSeen;
          let des = '';
          let show = false;

          if (risks && risks[0]) {
            lastSeen = risks[0].lastSeen;
            firstSeen = risks[0].firstSeen;
            if (risks[0].hasOwnProperty('riskType')) {
              des = risks[0].description;
            }
          }

          if (!resourceCreateInCloudnosys) {
            resourceCreateInCloudnosys = new Date();
          }

          let { creationOfRisk } = record;
          if (lastSeen && firstSeen) {
            scannedOn = firstSeen.toDate
              ? moment(firstSeen.toDate()).fromNow()
              : moment(new Date(firstSeen?._seconds * 1000)).fromNow();
            scannedOnTime = firstSeen.toDate
              ? moment(firstSeen.toDate()).fromNow()
              : moment(new Date(firstSeen?._seconds * 1000)).format('MMM Do, YYYY hh:mm a');

            if (scannedOn === 'Invalid date') {
              scannedOn = moment(lastSeen).fromNow();
              scannedOnTime = moment(firstSeen).format('MMM Do, YYYY hh:mm a');
            }
          } else if (creationOfRisk) {
            scannedOnTime = moment(creationOfRisk).format('MMM Do, YYYY hh:mm a');
            scannedOn = moment(creationOfRisk).fromNow();
          } else {
            scannedOn = 'N/A';
            scannedOnTime = 'N/A';
          }
          return (
            <span
              style={{
                cursor: 'pointer',
              }}
            >
              <div
                onClick={() => {
                  let drawerParams = [
                    {
                      type: 'resourceId',
                      value: [record.id],
                    },
                    {
                      type: 'cloudAccounts',
                      value: [record.cloudAccountId],
                    },
                  ];

                  this.openDrawer(drawerParams, 'singleResource', true);
                }}
                style={{
                  cursor: 'pointer',
                  fontWeight: 500,
                  fontSize: '13px',
                  marginTop: -7,
                }}
              >
                {show ? des : ''}
                {show ? <br /> : ''}
                {name}
                <LoginOutlined
                  onClick={() => {
                    let drawerParams = [
                      {
                        type: 'resourceId',
                        value: [record.id],
                      },
                      {
                        type: 'cloudAccounts',
                        value: [record.cloudAccountId],
                      },
                    ];

                    this.openDrawer(drawerParams, 'singleResource', true);
                  }}
                  style={{ color: '#1890FF', marginLeft: '5px' }}
                />
              </div>
              {resourceStatus === 'fail' && (
                <Fragment>
                  <div style={{ fontSize: '13px', color: '#F4657C', lineHeight: '1.2' }}>
                    {statusMessage}
                  </div>
                  <div
                    style={{
                      marginTop: '1px',
                      marginBottom: '-8px',
                      fontSize: '12px',
                      color: ' #8C8C8C',
                      fontWeight: 400,
                    }}
                  >
                    {' '}
                    <Row align="middle">
                      <Tooltip title={`First Seen: ${scannedOnTime && scannedOnTime}`}>
                        <ClockCircleOutlined style={{ fontSize: '13px', paddingRight: 5 }} />

                        {scannedOn && scannedOn}
                      </Tooltip>
                      {riskType == 'malware' && this.getInfectedFiles()?.length && (
                        <span
                          onClick={() => this.setState({ InfectModal: true })}
                          style={{
                            marginLeft: 5,
                            color: '#1890FF',
                            backgroundColor: '#E6F7FF',
                            padding: 5,
                            borderRadius: 5,
                            fontWeight: 500,
                          }}
                        >
                          {`Show infected files (${this.getInfectedFiles()?.length})`}
                        </span>
                      )}
                    </Row>
                  </div>
                </Fragment>
              )}
            </span>
          );
        },
      },

      {
        title: 'Service',
        dataIndex: 'service',
        key: 'service',

        render: service => (
          <Tooltip title={AllServices.getFullName(service)}>
            <Tag style={{ textAlign: 'center' }} color="blue">
              {AllServices.getShortName(service)}
            </Tag>
          </Tooltip>
        ),
      },
      {
        title: 'Region',
        dataIndex: 'region',
        key: 'region',

        render: region => {
          region = region && !Array.isArray(region) ? region : 'Global';
          region = capitalizeFirstLetter(region);
          return (
            <Tooltip title={region ? region : ''}>
              <Tag color="blue" style={{ textAlign: 'center' }}>
                {region.length > 6 && typeof region === 'string'
                  ? region.substring(0, 6).concat('...')
                  : region}
              </Tag>
            </Tooltip>
          );
        },
      },
      {
        title: 'VPC',
        dataIndex: 'vpcId',
        key: 'vpcId',
        // width: 100,
        render: vpcId =>
          vpcId === ''
            ? (vpcId = 'N/A')
            : vpcId === null
            ? 'N/A'
            : (vpcId = (
                <Tooltip title={vpcId}>
                  <Tag color="blue" style={{ marginLeft: '-15px' }}>
                    {vpcId.length > 6 ? vpcId.substring(0, 6).concat('..') : vpcId}
                  </Tag>
                </Tooltip>
              )),
      },
      {
        title: 'Account',
        dataIndex: 'cloudAccountId',
        key: 'cloudAccountId',
        // width: 115,
        render: (cloudAccountId, record) => {
          let res = getCloudAccountName(allCloudAccountsList, cloudAccountId);
          if (!res) {
            return null;
          }
          let cloudAccountName = '';
          let provider = '';
          if (res.length > 0) {
            provider = res[0].provider;
            cloudAccountName = res[0].cloudAccountName;
          }
          return (
            <span style={{ marginLeft: -18 }}>
              <Tooltip title={cloudAccountName ? cloudAccountName : ''}>
                <Tag style={{ paddingTop: '2px', marginLeft: 12 }}>
                  {cloudAccountName.length > 8
                    ? cloudAccountName.substring(0, 8).concat('...')
                    : cloudAccountName}
                  {provider && provider === 'AWS' ? (
                    <img
                      src="/awslogo.png"
                      alt="aws"
                      height="18px"
                      style={{ marginBottom: '5px' }}
                    />
                  ) : provider && provider === 'AZURE' ? (
                    <img
                      src="/azure@2x.png"
                      alt="azure"
                      height="18px"
                      style={{ marginBottom: '5px', marginLeft: '6px', height: '12px' }}
                    />
                  ) : (
                    <img
                      src="/gcplogo.png"
                      alt="gcp"
                      height="18px"
                      style={{
                        marginBottom: '2px',
                        marginRight: '-10px',
                        height: '20px',
                        marginLeft: '-4px',
                      }}
                    />
                  )}
                </Tag>
              </Tooltip>
            </span>
          );
        },
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (status, record) => {
          const { creationOfRisk, risks } = record;

          let scannedOn;
          let scannedOnTime;
          let lastSeen;
          let firstSeen;
          try {
            if (risks && risks[0]) {
              lastSeen = risks[0].lastSeen;
              firstSeen = risks[0].firstSeen;
            }

            if (lastSeen && firstSeen) {
              scannedOnTime = scannedOn = lastSeen.toDate
                ? moment(lastSeen.toDate()).fromNow()
                : moment(new Date(lastSeen?._seconds * 1000)).format('MMM Do, YYYY hh:mm a');
            } else if (creationOfRisk) {
              scannedOnTime = moment(creationOfRisk).format('MMM Do, YYYY hh:mm a');
            } else {
              scannedOnTime = 'N/A';
            }
          } catch (error) {
            console.log(error);
          }

          if (record.resourceStatus === 'fail' || record.status === 'fail') {
            return (
              <Tooltip overlayStyle={{ maxWidth: 700 }} title={`Last Scanned: ${scannedOnTime}`}>
                <LegacyIcon
                  style={{
                    color: '#F4657C',
                    fontSize: 25,
                    marginLeft: '5px',
                  }}
                  type="close-circle-o"
                />
              </Tooltip>
            );
          } else {
            return (
              <Tooltip title={`Last Scanned: ${scannedOnTime}`}>
                <LegacyIcon
                  style={{
                    color: '#3ADFA3',
                    fontSize: 25,
                    marginLeft: '5px',
                  }}
                  type="check-circle-o"
                />
              </Tooltip>
            );
          }
        },
      },
      {
        title: 'Suppress',
        dataIndex: 'suppress',
        key: 'suppress',
        render: (name, record, i) => {
          let suppressProps = {
            i,
            type: 'resource',
            record,
            disabled: isSuppressionDisabled(record),
          };

          return (
            <div style={{ paddingLeft: '20%' }}>
              <FinderSuppressReason {...suppressProps} />
            </div>
          );
        },
      },
    ];
  }
  RenderPopoverContent = () => {
    return (
      <div style={{ width: '248px' }}>
        <Radio.Group
          onChange={e => {
            this.setState({
              value: e.target.value,
            });
          }}
          value={this.state.value}
        >
          <Radio style={radioStyle} value="Not Applicable">
            Not Applicable
          </Radio>
          <Divider style={{ margin: '9px 0px' }} />
          <Radio style={radioStyle} value="Not in Scope">
            Not in Scope
          </Radio>
          <Divider style={{ margin: '9px 0px' }} />
          <Radio style={radioStyle} value={this.state.inputVal}>
            <Input
              onChange={e => {
                this.setState({
                  value: e.target.value,
                  inputVal: e.target.value,
                });
              }}
              placeholder="Other reason"
              style={{ width: '170px' }}
              type="text"
            />
          </Radio>
        </Radio.Group>
        <div style={{ marginLeft: '57px', marginTop: '17px' }}>
          <Button
            onClick={() => {
              this.setState({
                visible: false,
              });
            }}
          >
            Cancel
          </Button>
          <Button
            loading={this.props.supLoading}
            onClick={this.multipleSuppress}
            type="primary"
            style={{ marginLeft: '4px' }}
          >
            Save
          </Button>
        </div>
      </div>
    );
  };
  multipleSuppress = () => {
    this.setState({
      visible: false,
    });
    let { selectedRowKeys } = this.state;

    const { currentUser, filteredResourcesOfSingleRisk } = this.props;

    let risks = filteredResourcesOfSingleRisk;

    // Assuming risks is an array of objects with the structure { id, risks: [...] }
    // Assuming selectedRowKeys is an array of keys (ids) for the selected rows

    let paramsArray = selectedRowKeys.map(selectedKey => {
      const currentRisk = risks.find(risk => risk.id === selectedKey);

      let signatureName = '';

      // Handle the case where the risk are cves and malwares
      if (!_.isEmpty(currentRisk.cloudXRayRisks)) {
        const cvesObj = currentRisk.cloudXRayRisks.CVEs;
        const malwares = currentRisk.cloudXRayRisks.malwares;
        const cvesSigName = Object.keys(cvesObj).join('|');
        const malwareSigName = Object.keys(malwares).join('|');
        if (cvesSigName) {
          if (malwareSigName) {
            signatureName = cvesSigName + '|' + malwareSigName;
          } else {
            signatureName = cvesSigName;
          }
        } else {
          signatureName = malwareSigName;
        }
      } else {
        signatureName = currentRisk.risks.find(risk => risk.resourceId === selectedKey)
          .signatureName;
      }
      const cloudAccountId = currentRisk.cloudAccountId;
      const resourceId = currentRisk.resourceId;
      const regulationId = '.*';
      const createdBy = currentUser.name || '';
      const reason = this.state.value;

      const params = {
        cloudAccount: cloudAccountId,
        resourceId,
        signatureName,
        regulationId,
        createdBy,
        reason,
      };

      let suppressObj = makeSuppressObj(params);

      return suppressObj;
    });

    if (paramsArray.length > 0) {
      const { dispatch } = this.props;
      userCan('create-suppress', () => {
        dispatch({
          type: 'suppression/createSuppress',
          payload: {
            type: 'add',
            suppressionData: paramsArray,
          },
        });
      })();
    }
  };
  openDrawer = (params, drawerType, isCloud) => {
    const { appliedFilters } = this.props;

    let drawerParams = params;

    let isHistoryExist = appliedFilters.find(v => v.type === 'history');

    if (isHistoryExist) {
      drawerParams.push({
        type: 'history',
        value: [isHistoryExist.value[0]],
      });
    }

    pushParamsToUrl(drawerParams, drawerType);
  };

  render() {
    let {
      filteredResourcesOfSingleRisk,
      drawerLoading,
      description,
      showSuppress,
      riskType,
      signatureName,
      packageExpiry,
    } = this.props; // dataSource

    const { selectedRowKeys } = this.state;
    let locale;

    if (!filteredResourcesOfSingleRisk) {
      return <Spin />;
    }

    if (filteredResourcesOfSingleRisk !== null) {
      locale = {
        emptyText: <EmptyData type="singleRiskEmptyData" />,
      };
    }
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange,
      // Column configuration not to be checked if the type is osVulnerabilities or malware or the risk is suppress already
      getCheckboxProps: record => {
        return {
          disabled:
            packageExpiry === 'expired' ||
            record?.suppress ||
            record.hasOwnProperty('cloudXRayRisks') ||
            compareStrings(record?.type, riskTypes.osVulnerabilities) ||
            compareStrings(record?.type, riskTypes.malware) ||
            compareStrings(record?.riskType, riskTypes.osVulnerabilities) ||
            compareStrings(record?.riskType, riskTypes.malware),

          suppress:
            record?.suppress ||
            record.hasOwnProperty('cloudXRayRisks') ||
            compareStrings(record?.type, riskTypes.osVulnerabilities) ||
            compareStrings(record?.type, riskTypes.malware) ||
            compareStrings(record?.riskType, riskTypes.osVulnerabilities) ||
            compareStrings(record?.riskType, riskTypes.malware),
        };
      },
    };
    const hasSelected = selectedRowKeys.length > 0;
    const columns = this.getTableCloumns();
    let suppressResourceCount = filteredResourcesOfSingleRisk.filter(v => v.suppress === true)
      .length;
    if (!showSuppress) {
      filteredResourcesOfSingleRisk = getUnSuppressedRisks(filteredResourcesOfSingleRisk);
    }

    // filteredResourcesOfSingleRisk = sortData(filteredResourcesOfSingleRisk);
    // filteredResourcesOfSingleRisk = getFailedResources(filteredResourcesOfSingleRisk, description);
    //
    // if (dataSource === undefined) {
    //   dataSource = '';
    // }
    return (
      <Fragment>
        <Card bodyStyle={{ padding: '0px' }} bordered={false}>
          <Row>
            <Col span={12}>
              {hasSelected && (
                <div style={{ marginBottom: 16 }}>
                  <span style={{ marginLeft: 8, color: '#1890FF' }}>
                    <InfoCircleOutlined style={{ fontSize: 20, marginLeft: 10, marginRight: 10 }} />

                    {hasSelected ? `${selectedRowKeys.length} Resource(s) selected ` : ''}
                  </span>
                  <Button
                    type="default"
                    style={{ marginLeft: 10 }}
                    onClick={() => {
                      this.setState({
                        selectedRowKeys: [],
                      });
                    }}
                    disabled={!hasSelected}
                  >
                    Cancel
                  </Button>
                  <Popover
                    placement="bottomRight"
                    style={{ width: '40px' }}
                    key="this.props.i"
                    content={this.RenderPopoverContent()}
                    title="Suppress these risks"
                    trigger="click"
                    visible={this.state.visible}
                  >
                    <Button
                      type="primary"
                      loading={this.props.supLoading}
                      style={{ marginLeft: 10 }}
                      onClick={() => {
                        this.setState({
                          visible: true,
                        });
                      }}
                      disabled={!hasSelected}
                    >
                      Suppress
                    </Button>
                  </Popover>
                </div>
              )}
            </Col>
          </Row>
          <Table
            scroll={{ y: 'calc(100vh - 420px)' }} //  dataSource !== '' ? 'calc(100vh - 20px)' : 'calc(100vh - 420px)'
            columns={columns}
            rowClassName={record => {
              return record.suppress ? styles.tableRow : '';
            }}
            pagination={true}
            rowSelection={rowSelection}
            rowKey={record => record.id}
            dataSource={filteredResourcesOfSingleRisk}
            // locale={!drawerLoading && locale}
            loading={drawerLoading}
          />
        </Card>
        {riskType === 'malware' && (
          <InfectedFilesModal
            isOpen={this.state.InfectModal}
            record={filteredResourcesOfSingleRisk}
            signatureName={signatureName}
            closeModal={() => this.setState({ InfectModal: false })}
          />
        )}
      </Fragment>
    );
  }
}

export default SingleSignatureResourcesTable;

function getUnSuppressedRisks(data) {
  return data.filter(v => v.suppress === false);
}
function sortData(data) {
  //
  // return statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status);
  return data.sort((a, b) => {
    let pass = a.status.toLowerCase();
    let fail = b.status.toLowerCase();

    if (pass < fail) {
      return -1;
    } else if (pass > fail) {
      return 1;
    }
    return 0;
  });
}

function getFailedResources(data, description) {
  let resourcesWithRisks = data.reduce((acc, eachRisk) => {
    // loop risks
    const riskWithFailedRes = eachRisk.risks.filter(
      val => val.signatureName === description && val.status.toLowerCase() === 'fail'
    );

    if (riskWithFailedRes.length === 0) return acc;

    return [...acc, eachRisk];
  }, []);

  return resourcesWithRisks;
}
